import { render, staticRenderFns } from "./HeartIcon.vue?vue&type=template&id=1021c110&"
import script from "./HeartIcon.vue?vue&type=script&lang=ts&"
export * from "./HeartIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1021c110', component.options)
    } else {
      api.reload('1021c110', component.options)
    }
    module.hot.accept("./HeartIcon.vue?vue&type=template&id=1021c110&", function () {
      api.rerender('1021c110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/HeartIcon.vue"
export default component.exports